<div class="container">
  <section class="form-tasklist">

    <mat-accordion class="training-accordion" multi>
      @for (training of listTraining; track training.trainingQuizNumber) {

        <mat-expansion-panel
          [expanded]="step === training.trainingQuizNumber"
          (opened)="setStep(training.trainingQuizNumber)">

          <mat-expansion-panel-header>
            <mat-panel-title class="panel-title">

              <!-- Status icon: use a wrapper, not mat-icon with innerHTML -->
              <span
                class="status-icon"
                [ngClass]="quizsectionStatus(training.isPassed)"
                [innerHTML]="loadTaskStatusIconHtml(training.isPassed, training.trainingQuizNumber)">
              </span>

              <strong class="heading">{{ training.sectionHeading }}</strong>
            </mat-panel-title>

            <!-- If you want to hide the expand/collapse indicator -->
            @if (hideToggle) {
              <span class="no-toggle"></span>
            }
          </mat-expansion-panel-header>

          <div class="panel-body">
            <h4 class="section-title">{{ training.sectionTitle }}</h4>

            <div class="section-text" [innerHTML]="training.sectionText"></div>

            <div class="video-container" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="25px">

              <!-- Left column -->
              <div fxFlex="50" class="left-col">
                <div class="video-content-normal">
                  <p [innerHTML]="training.videoText"></p>

                  @if (training.videoUrl && training.videoUrl.length > 0) {
                    <button
                      mat-stroked-button
                      color="primary"
                      type="button"
                      (click)="openModal(training.videoUrl)">
                      {{ training.watchButtonText || 'Watch Now' }}
                    </button>
                  }

                  <p class="pdf-text" [innerHTML]="training.pdfText"></p>
               <div class="training-actions">
                  @if (training.pdfUrl?.length > 0) {
                    <a
                      mat-stroked-button
                      color="primary"
                      [href]="training.pdfUrl"
                      target="_blank"
                      rel="noopener"
                      [id]="training.pdfViewText + '-' + training.trainingQuizNumber"
                      [attr.aria-label]="'pdf-' + training.trainingQuizNumber">
                      {{ training.pdfViewText || 'View PDF' }}
                    </a>
                  }

                  @if (
                    training.trainingFile?.length > 0 &&
                    currentUser?.isContractor === true &&
                    training.isshowQuiz === true
                  ) {
                    <button
                      mat-stroked-button
                      color="primary"
                      type="button" style="margin-right: 10px;"
                      (click)="openquiz(training.trainingQuizNumber)"
                      [attr.aria-label]="'Take the Quiz--' + training.trainingQuizNumber"
                      [attr.data-quiz-id]="training.id"
                      [attr.data-quiz-number]="training.trainingQuizNumber">
                      Take the Quiz
                    </button>
                  }
</div>
                  @if (currentUser?.isContractor === true && training.isPassed === true) {
                    <div class="quiz-msg success">
                      Congratulations! You passed the quiz!
                    </div>
                  }

                  @if (currentUser?.isContractor === true && training.isPassed === false) {
                    <div class="quiz-msg error">
                      Please re-take the quiz to complete this section.
                    </div>
                  }

                  @if (
                    currentUser?.isContractor === true &&
                    training.isPassed === null &&
                    training.isshowQuiz === false
                  ) {
                    <div class="quiz-msg error">
                      Please complete the previous section(s) of the Quiz.
                    </div>
                  }
                </div>
              </div>

              <!-- Right column -->
              <div fxFlex="50" class="right-col">
                @if (training.videoTeaserImage?.length > 0) {
                  <button
                    type="button"
                    class="video-teaser-btn"
                    (click)="openModal(training.videoUrl)"
                    [attr.aria-label]="'video-' + training.trainingQuizNumber">

                    <span class="play-icon" aria-hidden="true"></span>

                    <img
                      class="video-teaser"
                      [src]="training.videoTeaserImage"
                      [alt]="'Image-' + training.trainingQuizNumber" />
                  </button>
                }
              </div>

            </div>

           
              <div class="bottom-text" [innerHTML]="training.bottomSectionText"></div>
            
          </div>

        </mat-expansion-panel>
      }
    </mat-accordion>

    @if (showPopup) {
      <app-video-popup [videoUrl]="currentVideoUrl"></app-video-popup>
    }

  </section>
</div>
